import { render, staticRenderFns } from "./ComplianceContactsInfo.vue?vue&type=template&id=154a9d83&scoped=true&"
import script from "./ComplianceContactsInfo.vue?vue&type=script&lang=ts&"
export * from "./ComplianceContactsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ComplianceContactsInfo.vue?vue&type=style&index=0&id=154a9d83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a9d83",
  null
  
)

export default component.exports